var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArt5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 128,
    viewBox: "0 0 121 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.75 108H11.25C11.112 108 11 107.888 11 107.75V20.25C11 20.112 11.112 20 11.25 20H74.75C74.888 20 75 20.112 75 20.25V107.75C75 107.888 74.888 108 74.75 108Z",
    fill: "#5C546A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51 6H29V14H51V6Z",
    fill: "#5C546A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51 110H35V126H51V110Z",
    fill: "#5C546A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69 0H17C11.4862 0 7 4.48625 7 10V118C7 123.514 11.4862 128 17 128H69C74.5137 128 79 123.514 79 118V10C79 4.48625 74.5137 0 69 0ZM39 8H47C48.1055 8 49 8.8945 49 10C49 11.1055 48.1055 12 47 12H39C37.8945 12 37 11.1055 37 10C37 8.8945 37.8945 8 39 8ZM31.58 8.58C32.2987 7.85925 33.6795 7.83975 34.4198 8.58C34.7793 8.959 34.9997 9.459 34.9997 10C34.9997 10.539 34.779 11.039 34.4198 11.42C34.039 11.7793 33.539 12 33 12C32.459 12 31.959 11.7793 31.58 11.42C31.2188 11.039 31 10.539 31 10C31 9.459 31.2188 8.959 31.58 8.58ZM43 124C39.6925 124 37 121.308 37 118C37 114.692 39.6925 112 43 112C46.3075 112 49 114.692 49 118C49 121.308 46.3075 124 43 124ZM73 108H13C11.8955 108 11 107.104 11 106V22C11 20.8955 11.8955 20 13 20H73C74.1045 20 75 20.8955 75 22V106C75 107.104 74.1045 108 73 108Z",
    fill: "#00A1E1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M113 102H25C20.5817 102 17 98.4183 17 94V34C17 29.5817 20.5817 26 25 26H113C117.418 26 121 29.5817 121 34V94C121 98.4183 117.418 102 113 102Z",
    fill: "#5D647F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53 58H33C30.7908 58 29 56.2092 29 54V42C29 39.7908 30.7908 38 33 38H53C55.2092 38 57 39.7908 57 42V54C57 56.2092 55.2092 58 53 58Z",
    fill: "#FFD100"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39 80H33C30.7908 80 29 78.2092 29 76C29 73.7908 30.7908 72 33 72H39C41.2092 72 43 73.7908 43 76C43 78.2092 41.2092 80 39 80Z",
    fill: "#B8BAC0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M61 80H55C52.7908 80 51 78.2092 51 76C51 73.7908 52.7908 72 55 72H61C63.2092 72 65 73.7908 65 76C65 78.2092 63.2092 80 61 80Z",
    fill: "#B8BAC0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M83 80H77C74.7908 80 73 78.2092 73 76C73 73.7908 74.7908 72 77 72H83C85.2092 72 87 73.7908 87 76C87 78.2092 85.2092 80 83 80Z",
    fill: "#B8BAC0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M105 80H99C96.7908 80 95 78.2092 95 76C95 73.7908 96.7908 72 99 72H105C107.209 72 109 73.7908 109 76C109 78.2092 107.209 80 105 80Z",
    fill: "#B8BAC0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2 92H30.8C29.805 92 29 91.1045 29 90C29 88.8955 29.805 88 30.8 88H63.2C64.195 88 65 88.8955 65 90C65 91.1045 64.195 92 63.2 92Z",
    fill: "#8A8895"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M85 92H71C69.8945 92 69 91.1045 69 90C69 88.8955 69.8945 88 71 88H85C86.1055 88 87 88.8955 87 90C87 91.1045 86.1055 92 85 92Z",
    fill: "#8A8895"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M93 54.0013C91.1755 56.4295 88.2712 58 85.0002 58C79.4775 58 75.0002 53.5227 75.0002 48C75.0002 42.4773 79.4775 38 85.0002 38C88.2687 38 91.1707 39.568 92.9955 41.9927",
    fill: "#FF4F19"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M99 58C104.523 58 109 53.5228 109 48C109 42.4772 104.523 38 99 38C93.4772 38 89 42.4772 89 48C89 53.5228 93.4772 58 99 58Z",
    fill: "#FFD100"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M39 46V38H35V58H39V50H57V46H39Z",
    fill: "#FF9500"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArt5);
export default __webpack_public_path__ + "static/media/art5.7512b887cef173fb399194b637439a94.svg";
export { ForwardRef as ReactComponent };